<template>
  <div v-if="visible" class="sales-modal-overlay" @click.self="$emit('close')">
    <div class="sales-modal-box">
      <div class="sales-modal-hd">
        <h3>
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="9" width="3" height="6" rx="1" fill="#009bbf"/><rect x="6" y="5" width="3" height="10" rx="1" fill="#009bbf"/><rect x="11" y="1" width="3" height="14" rx="1" fill="#009bbf"/></svg>
          販売個数 — {{ asin }}
        </h3>
        <button class="sales-modal-close" @click="$emit('close')">×</button>
      </div>
      <div class="sales-modal-bd">
        <div class="sales-modal-section-label">期間選択</div>
        <div class="sales-period-selector">
          <button
            v-for="d in [7, 30, 60, 90]"
            :key="d"
            class="sales-period-btn"
            :class="{ active: days === d }"
            @click="$emit('change-days', d)"
          >{{ d }}日</button>
        </div>
        <div class="sales-modal-section-label">販売個数 — {{ days }}日間</div>
        <div class="sales-modal-total-row">
          <span class="sales-modal-total-num">{{ total.toLocaleString() }}</span>
          <span class="sales-modal-total-unit">個</span>
          <span class="sales-modal-period-range">（{{ dateRange }}）</span>
        </div>
        <div class="sales-modal-section-label" style="margin-top:12px;">日別売上</div>
        <div class="sales-chart-wrap">
          <bar-chart
            v-if="chartData"
            :chart-data="chartData"
            :options="chartOptions"
            :height-number="280"
          />
          <div v-else class="sales-chart-empty">データがありません</div>
        </div>
        <div class="sales-chart-legend">
          <span class="sales-legend-bar"></span>
          <span class="sales-legend-label">販売個数</span>
        </div>
      </div>
      <div class="sales-modal-ft">
        <button class="btn btn-default" @click="$emit('close')">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/BarChart'
import moment from 'moment'

export default {
  name: 'SalesModal',
  components: { BarChart },
  props: {
    visible: { type: Boolean, default: false },
    asin: { type: String, default: '' },
    days: { type: Number, default: 30 },
    total: { type: Number, default: 0 },
    chartData: { type: Object, default: null },
    chartOptions: { type: Object, default: () => ({}) }
  },
  computed: {
    dateRange () {
      const end = moment()
      const start = moment().subtract(this.days - 1, 'days')
      const fmt = d => `${d.year()}年${d.month() + 1}月${d.date()}日`
      return `${fmt(start)} 〜 ${fmt(end)}`
    }
  }
}
</script>

<style scoped>
.sales-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.42);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sales-modal-box {
  background: #fff;
  border-radius: 8px;
  width: 750px;
  max-width: 95vw;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  max-height: 80vh;
}
.sales-modal-hd {
  background: #d0f2f8;
  border-bottom: 1px solid #7dcee8;
  padding: 11px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}
.sales-modal-hd h3 {
  font-size: 13px;
  color: #005f78;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
}
.sales-modal-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}
.sales-modal-close:hover { color: #c00; }
.sales-modal-bd {
  padding: 16px;
  overflow-y: auto;
}
.sales-period-selector {
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
}
.sales-period-btn {
  font-size: 12px;
  padding: 4px 14px;
  border: 1px solid #7dcee8;
  background: #e6f8fb;
  border-radius: 3px;
  cursor: pointer;
  color: #007a96;
  font-weight: bold;
}
.sales-period-btn:hover { background: #bceef8; }
.sales-period-btn.active {
  background: #009bbf;
  color: #fff;
  border-color: #009bbf;
}
.sales-modal-total-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 12px;
}
.sales-modal-total-num {
  font-size: 36px;
  font-weight: bold;
  color: #007a96;
}
.sales-modal-total-unit { font-size: 18px; color: #333; }
.sales-modal-period-range {
  font-size: 11px;
  color: #888;
}
.sales-chart-wrap {
  position: relative;
}
.sales-chart-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 12px;
  color: #aaa;
}
.sales-modal-ft {
  border-top: 1px solid #eee;
  padding: 10px 16px;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}
.sales-modal-section-label {
  font-size: 13px;
  font-weight: bold;
  color: #007a96;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
  margin-bottom: 8px;
}
.sales-chart-legend {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 18px;
}
.sales-legend-bar {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background: rgba(36,113,163,0.85);
}
.sales-legend-label {
  font-size: 13px;
  color: #555;
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/SalesModal.vue